<section 
  class="tw-relative tw-cursor-pointer tw-w-full" 
  id="{{ inputId }}" 
  (click)="toggleDropdown()" 
  [formGroup]="formGroup" 
  cdkOverlayOrigin 
  #trigger="cdkOverlayOrigin" 
  #inputSection
  tabindex="0"
  [attr.aria-expanded]="isOpen"
  [attr.aria-haspopup]="'listbox'"
  [attr.aria-labelledby]="inputId"
  role="combobox">
  <input
    class="tw-w-full tw-rounded-xl focus-visible:tw-border-border-main focus-visible:tw-outline-0 tw-py-2 tw-px-5 tw-border-border-light-gray tw-text-main-text focus-visible:tw-border-2 tw-border disabled:tw-bg-white tw-cursor-pointer tw-select-none {{
      customClasses
    }}"
    [placeholder]="placeholder"
    [value]="displayValue"
    [ngClass]="{ '!tw-bg-second-disabled': disabled }"
    readonly
  />
  <input [formControlName]="keyControl" hidden />
  
  <!-- Clear button -->
  <div 
    *ngIf="showClearButton && displayValue && !disabled"
    class="tw-absolute tw-right-[35px] tw-inset-y-0 tw-flex tw-items-center tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600"
    (click)="clearSelection(); $event.stopPropagation()">
    <i class="fas fa-times tw-text-sm"></i>
  </div>
  
  <!-- Dropdown arrow -->
  <div
    class="tw-absolute tw-flex tw-justify-center tw-right-[10px] tw-inset-y-0 tw-w-[20px] tw-h-[20px] tw-m-auto tw-text-main"
    [@rotate]="isOpen ? '180' : 0"
  >
    <i class="{{ iconClass }}"></i>
  </div>
</section>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayWidth]="inputWidth"
  [cdkConnectedOverlayMinWidth]="200"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'tw-bg-transparent'"
  (backdropClick)="onBackdropClick()"
  (detach)="onOverlayDetach()"
>
  <mh-core-lib-generic-box #optionsMenu id="optionsMenu" customClass="tw-mt-2 !tw-py-0 tw-w-full tw-min-w-[200px]">
    <section 
      class="tw-py-1 tw-overflow-auto"
      [style.max-height]="maxHeight + 'px'"
      role="listbox"
      [attr.aria-labelledby]="inputId">
      <ng-container *ngFor="let option of options; let i = index; trackBy: trackByFn">
        <div
          [class]="getOptionClasses(option, i)"
          (click)="selectOption(option)"
          role="option"
          [attr.aria-selected]="isOptionSelected(option)"
          [attr.data-index]="i"
        >
          {{ displayFn(option) }}
        </div>
      </ng-container>
      
      <!-- Empty state -->
      <div 
        *ngIf="options.length === 0" 
        class="tw-py-3 tw-px-3 tw-text-center tw-text-gray-500 tw-text-sm">
        No options available
      </div>
    </section>
  </mh-core-lib-generic-box>
</ng-template>
